import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'environments/environment';

@Component({
  selector: 'app-index',
  templateUrl: './index.component.html',
  styleUrls: ['./index.component.scss']
})
export class IndexComponent implements OnInit {

	production:boolean;

	constructor(private http: HttpClient) {
	}

	ngOnInit() {
		this.production=environment.production;
	}

	throwError() {
		throw new Error('My Pretty Error*');
    }
    throwOtherError()
    {
        throw new Error('Other My Pretty Error*');
    }

	throwHttpError() {
		this.http.post('esta es un test***',{}).subscribe();
	}
}
